import { Platform } from 'react-native';

import { RunningExperiments, useExperiments } from 'state/experiments';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

type VariantFnType = ReturnType<typeof useExperiments>['variant'];

const localStorageVariantFn: VariantFnType = (experimentFlag, expectedVariant) => {
  const experiments = LocalStorage.getItem(StorageKeys.AMPLITUDE_VARIANTS) ?? {};
  const reactNativeNavigationExperiment = experiments[experimentFlag] ?? {};
  return reactNativeNavigationExperiment.value === expectedVariant;
};

// This function can be used outside of react contexts
// to get the value in the instant it's called
export function isReactNavigationEnabled(variantFn: VariantFnType = localStorageVariantFn) {
  /*
   * React Navigation for web is still in experimental phase
   * Fallback to legacy navigation until implemented
   * https://reactnavigation.org/docs/web-support/
   */
  if (Platform.OS === 'web') {
    return false;
  }

  return variantFn(RunningExperiments.ReactNativeNavigation, 'treatment');
}

export const useReactNavigationFlag = () => {
  const { variant } = useExperiments();
  return isReactNavigationEnabled(variant);
};
